import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { InfoIcon, Tooltip } from '@beef/ui-kit';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const TooltipWrapper: FC<{ message: string }> = ({ message }) => (
  <div className={cn('component')}>
    <Tooltip message={message} position="top">
      <InfoIcon fill="#727281" size={16} />
    </Tooltip>
  </div>
);
